import { useParams as useRouterParams } from 'react-router-dom';

// Re-exporting this with generic types
export function useParams(): Record<string, string> {
  return useRouterParams();
}
